import React from 'react'
import styles from './Content.module.css'

interface Content {
  padding?: boolean
  children?: React.ReactNode
}

function Content({ padding = true, children }: Content) {
  return (
    <div className={padding ? styles.content : styles.contentNoPadding}>
      {children}
    </div>
  )
}

export default Content
